import { InternalOnlyPublishVisibility } from "../../../../contexts/PublishingContext.js";
import { LayoutBuilderRenderer } from "../../../../components/LayoutBuilder/LayoutBuilderRenderer.js";
import { FormBuilderFieldsContextProvider } from "../../contexts/FormBuilderFieldsContext.js";
import { useFormSchema } from "../../hooks/useFormSchema.js";
import { FieldDisplayRenderer } from "./components/FieldDisplayRenderer.js";
import { useCallback } from "react";
import { Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import warnOnce from "warn-once";
//#region src/modules/FormBuilder/components/FormBuilderDisplayRenderer/index.tsx
var FormBuilderDisplayRenderer = ({ formId, valuesByFieldId }) => {
	const { form, loading } = useFormSchema(formId);
	const renderComponentFromId = useCallback((componentId) => {
		if (!form) return null;
		const field = form.formBuilder.fieldsById[componentId];
		if (!field) {
			warnOnce(true, `FormBuilderDisplayRendered componentId ("${componentId}") not found in fieldsById`);
			return null;
		}
		if (field.internal) return /* @__PURE__ */ jsx(InternalOnlyPublishVisibility, {
			isInternal: field.internal,
			children: /* @__PURE__ */ jsx(FieldDisplayRenderer, { field })
		});
		return /* @__PURE__ */ jsx(FieldDisplayRenderer, { field });
	}, [form, valuesByFieldId]);
	if (loading || !form) return /* @__PURE__ */ jsx("div", {
		className: "my-base flex w-full justify-between align-middle",
		children: /* @__PURE__ */ jsx(Loading, { message: "Loading Form" })
	});
	if (form.formBuilder.formLayout.schemaVersion !== "1") return /* @__PURE__ */ jsxs("div", {
		className: "text-color-critical",
		children: [
			"Not a valid Form Builder schema (Schema Version: \"",
			form.formBuilder.formLayout.schemaVersion,
			"\")"
		]
	});
	return /* @__PURE__ */ jsx(FormBuilderFieldsContextProvider, {
		values: valuesByFieldId,
		children: /* @__PURE__ */ jsx(LayoutBuilderRenderer, {
			layout: form.formBuilder.displayLayout,
			renderComponentFromId
		})
	});
};
//#endregion
export { FormBuilderDisplayRenderer };

//# sourceMappingURL=index.js.map